export const mutations = {
  addFacture (state, facture) {
    state.facture = facture
  },
  setFacture (state, facture) {
    state.facture = facture
  },
    addFactures(state, facture){
    state.factures = facture
  },
  addFacturesPage(state, facture) {
    state.factures = facture;
  },
}
